import { useState } from "react";
import DecadeBorn from "./MyprofileModal/DecadeBorn";

function MyProfile() {
	
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [aboutMe, setAboutMe] = useState("");
 
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
 
  const handleSave = () => {
    setIsModalOpen(false);
  };
	
	
  return (
    <>
    <section className="ser_v_araeea mng_bottomss user_allls profiles all_titless myprofiless">
		<div className="container">
			<div className="prfo_listst lastsst pt-0">
					<div className="add_on_profils">
						<div className="discriptionns">
							<h3>Add your online profiles</h3>
							<p className="sm_diss">We’ll review your profiles and may suggest content and photos to improve your listing, Guests won’t see these links</p>
						</div>

						<div className="form_al_fildss">
							<form action="">
								<div className="row">
									<div className="col-lg-6">
										<div className="form-group">
											<label>Social Media</label>
											<input className="form-control" placeholder="" type="text" />
										</div>
									</div>

									<div className="col-lg-6">
										<div className="form-group">
											<label>Others</label>
											<input className="form-control" placeholder="" type="text" />
										</div>
									</div>

									<div className="col-lg-6">
										<div className="form-group">
											<label>Social Media</label>
											<input className="form-control" placeholder="" type="text" />
										</div>
									</div>

									<div className="col-lg-6">
										<div className="form-group">
											<label>Others</label>
											<input className="form-control" placeholder="" type="text" />
										</div>
									</div>
								</div>

								
								{/* Where should guests meet you ? */}
								<div className="discriptionns">
									<h3>Where should guests meet you ?</h3>
									<p className="sm_diss">Guests will see this address on your listing</p>
								</div>

								<div className="row">
									<div className="col-lg-6">
										<div className="form-group">
											<label>Country/Region</label>
											<select className="form-control">
												<option value=""></option>
											</select>
										</div>
									</div>

									<div className="col-lg-6">
										<div className="form-group">
											<label>Flat , house etc</label>
											<input className="form-control" placeholder="" type="Enter Flat house" />
										</div>
									</div>

									<div className="col-lg-6">
										<div className="form-group">
											<label>Locality/street adress</label>
											<input className="form-control" placeholder="Enter Location" type="text" />
										</div>
									</div>

									<div className="col-lg-6">
										<div className="form-group">
											<label>City/town</label>
											<input className="form-control" placeholder="Enter City" type="text" />
										</div>
									</div>

									<div className="col-lg-6">
										<div className="form-group">
											<label>Pincode</label>
											<input className="form-control" placeholder="Enter Pincode" type="text" />
										</div>
									</div>
									
									<div className="col-lg-12">
									 <div className="submmit">
									  <button type="submit" value="submit">Update</button>
									 </div>
									</div>
									
								</div>
							</form>
						</div>
					</div>
			</div>
		</div>
	</section>

	
	<DecadeBorn
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        aboutMe={aboutMe}
        setAboutMe={setAboutMe}
        onSave={handleSave}
      />
	  </>
	
  )
}



export default MyProfile